import externalTransactionFormModel from './externalTransactionFormModel';

const {
  formField: {
    siteId,
    quantity,
    unitPrice,
    amount,
    vehicleNumber,
    dateTime,
    odometerEntry,
  }
} = externalTransactionFormModel;

export default {
  [siteId.name]: '',
  [quantity.name]: '',
  [unitPrice.name]: '',
  [amount.name]: '',
  [vehicleNumber.name]: '',
  [dateTime.name]: '',
  [odometerEntry.name]: '',
};
